var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNeuro6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1875,
    height: 1552,
    viewBox: "0 0 1875 1552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.36 0H0V1551.73H1874.36V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M627.352 384.471C639.975 359.91 670.117 350.232 694.678 362.855L1404.1 727.451C1428.67 740.073 1438.34 770.216 1425.72 794.777L1247.23 1142.08C1234.61 1166.64 1204.58 1176.38 1180.02 1163.76C1102.87 1124.12 941.143 1041.02 825.472 981.535C710.047 922.174 547.74 838.778 470.382 799.035C445.817 786.414 436.245 756.324 448.869 731.761L627.352 384.471Z",
    fill: "url(#paint0_linear_538_3498)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_3498",
    x1: 1279.53,
    y1: 933.024,
    x2: 812.53,
    y2: 399.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055094",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DAAE2",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1875,
    height: 1552,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro6);
export default __webpack_public_path__ + "static/media/bg-neuro6.1b167896ccfd67dd6d0a261941ce7953.svg";
export { ForwardRef as ReactComponent };